import { render, staticRenderFns } from "./InplaySelectedGameNew.vue?vue&type=template&id=104d72aa&scoped=true"
import script from "./InplaySelectedGameNew.vue?vue&type=script&lang=js"
export * from "./InplaySelectedGameNew.vue?vue&type=script&lang=js"
import style0 from "./InplaySelectedGameNew.vue?vue&type=style&index=0&id=104d72aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d72aa",
  null
  
)

export default component.exports